import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withCookies } from 'react-cookie';

import { bindActionCreators } from 'redux';
import { checkIfAdmin, getRoleId, isLogin } from 'store/selectors/loginState';
import { selectAttribute } from 'shared/selectors';

import { actLogin } from '../Login/actions';
import View from './view';

const mapStateToProps = (state, { cookies }) => ({
  isAdmin: checkIfAdmin(state),
  isUserLogin: isLogin(state) && !!cookies.get('token'),
  roleId: getRoleId(state),
  loginLocked: selectAttribute('loginReducer', 'login.error.locked', false)(state),
});

const mapDispatchToProps = (dispatch) => ({
  onLogin: bindActionCreators(actLogin, dispatch),
});

export default withCookies(withRouter(connect(mapStateToProps, mapDispatchToProps)(View)));
